
import BlogTextColor from '~/components/Common/Blog/BlogTextColor'

export default {
    name: 'KOSDAQ',
    components: { BlogTextColor },
}
